"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const syncNotificationData_1 = __importDefault(require("./syncNotificationData"));
class SyncNotification {
    constructor(content) {
        this.type = bridge_schema_1.NotificationType.Sync;
        this.timestamp = Date.now();
        this.identifier = -1;
        this.date = 'today';
        this.status = bridge_schema_1.NotificationStatus.Unread;
        this.data = (0, syncNotificationData_1.default)(content);
    }
}
exports.default = SyncNotification;
